import { getTeamsDateFormat, getTeamsTimeFormat } from "../utils/dateUtils";

const pl = {
    common: {
        loader: "Načítanie údajov...",
        meetingCancelled: "Schôdza bola zrušená",
    },
    logo: {
        corporation: "Logo mBank pre firmy",
        retail: "Logo mBank pre retailových zákazníkov",
        private: "Logo mBank pre privátne bankovníctvo",
    },
    requestCancelMeeting: {
        actionButton: "Pošlite svoju požiadavku",
        pendingDescription: (startAt: Date) =>
            `Chcete odoslať organizátorovi žiadosť o zrušenie schôdze
            z ${getTeamsDateFormat(startAt)} o ${getTeamsTimeFormat(startAt)}?`,
        inProgressDescription: (startAt: Date) =>
            `Schôdza ${getTeamsDateFormat(startAt)} o ${getTeamsTimeFormat(startAt)} už prebieha alebo sa práve začína.
        Už nie je možné ho zrušiť. Ak potrebujete zrušiť schôdzu, obráťte sa na svojho poradcu.`,
        expiredDescription: (endAt: Date) =>
            `Schôdza sa skončila ${getTeamsDateFormat(endAt)} o ${getTeamsTimeFormat(
                endAt
            )} hod.\nZrušenie už nie je možné.`,
        requestSent:
            "Žiadosť o zrušenie schôdze bola odoslaná. Váš poradca vás bude čoskoro kontaktovať a potvrdí vám zrušenie.",
        redirectButton: "Neodosielať",
    },
    joinMeeting: {
        meetingNotFound:
            "Nenašla sa žiadna schôdza. Odkaz môže byť nesprávny. Skontrolujte správnosť a skúste to znova.",
        actionButton: "Začnite schôdzu",
        redirectButton: "Zrušte schôdzu",
        pendingDescription: (startAt: Date) =>
            `Schôdza sa začne ${getTeamsDateFormat(startAt)} o ${getTeamsTimeFormat(
                startAt
            )}.\nPripojenie bude možné 10 minút pred začatím.`,
        inProgressDescription:
            "Schôdza, ktorá sa čoskoro začne, bude nahrávaná.\nAk s tým nesúhlasíte, kliknite na tlačidlo Zrušiť schôdzu.",
        expiredDescription: (endAt: Date) =>
            `Schôdza sa skončila ${getTeamsDateFormat(endAt)} o ${getTeamsTimeFormat(
                endAt
            )} hod.\nPripojenie už nie je možné.`,
        wrongAddress:
            "Adresa schôdze je nesprávna. Skontrolujte, či sa adresa v prehliadači zhoduje s adresou odoslanou v e-maile.",
        failedToJoin:
            "Pripojenie k schôdzi zlyhalo. Odkaz môže byť nesprávny. Skontrolujte správnosť a skúste to znova.",
        browserUnsupportedError: (recommendedBrowsers: string) =>
            `Používate nepodporovaný prehliadač. Odporúčame vám používať najnovšiu verziu jedného z nasledujúcich prehliadačov ${recommendedBrowsers}`,
    },
};

export default pl;
